<!-- eslint-disable import/extensions -->
<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <div class="custom-toolbar">
                <div class="custom-toolbar-start">
                    <div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-30">
                                <md-datepicker
                                    v-model="searchDateFrom"
                                    :md-model-type="String"
                                    md-immediately
                                    class="md-layout-item"
                                >
                                    <label>From Date</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-30">
                                <md-field>
                                    <label>Detection Results Filter</label>
                                    <md-select v-model="selectedInvalidImageFilterType" md-no-validate>
                                        <md-option :value="0">Failed Detection</md-option>
                                        <md-option :value="1">House Number Mismatch</md-option>
                                        <md-option :value="2">No Filter (show all)</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-30">
                                <md-field>
                                    <label>Team Member</label>
                                    <md-select v-model="selectedTeamMemberId" md-no-validate>
                                        <md-option :value="0">All</md-option>
                                        <md-option
                                            v-for="member in teamMembers"
                                            :key="member.userId"
                                            :value="member.userId"
                                        >
                                            {{ member.firstName }} {{ member.lastName }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="custom-toolbar-end">
                    <div>
                        <md-button
                            title="Refresh List"
                            class="md-primary md-just-icon md-round pull-right header-button"
                            @click="onStartup"
                        >
                            <md-icon>refresh</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="md-title">Vision List</div>
                </md-card-header>
                <md-card-content>
                    <md-table>
                        <md-table-row>
                            <md-table-head>Date</md-table-head>
                            <md-table-head>Driver</md-table-head>
                            <md-table-head>Parcel?</md-table-head>
                            <md-table-head>House Num?</md-table-head>
                            <md-table-head>Image</md-table-head>
                        </md-table-row>
                        <md-table-row v-for="imageVision in imageVisionList" :key="imageVision.fileName">
                            <md-table-cell>
                                <router-link
                                    v-if="imageVision.stopId"
                                    :to="{
                                        name: 'Stop Details',
                                        params: {
                                            stopId: imageVision.stopId
                                        }
                                    }"
                                >
                                    {{ imageVision.noteDate | dateFormat(DATE_TYPES.standardDate) }}
                                </router-link>
                                <router-link
                                    v-else-if="imageVision.shipmentId"
                                    :to="{
                                        name: 'Shipment Details',
                                        params: {
                                            shipmentId: imageVision.shipmentId
                                        }
                                    }"
                                >
                                    {{ imageVision.noteDate | dateFormat(DATE_TYPES.standardDate) }}
                                </router-link>
                                <span v-else>{{ imageVision.noteDate | dateFormat(DATE_TYPES.standardDate) }}</span>
                            </md-table-cell>
                            <md-table-cell>{{ imageVision.driverName }}</md-table-cell>
                            <md-table-cell>
                                <md-icon v-if="imageVision.isParcelDetected" class="md-success">check</md-icon>
                                <md-icon v-else class="md-danger">close</md-icon>
                            </md-table-cell>
                            <md-table-cell>
                                <md-icon v-if="imageVision.isNumberDetected" class="md-success">check</md-icon>
                                <md-icon v-else class="md-danger">close</md-icon>
                            </md-table-cell>
                            <md-table-cell>
                                <a :href="imageVision.fileName" download target="_blank">
                                    <img class="thumbnail-icon" :src="imageVision.thumbFileName" alt="" />
                                </a>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { handleRequests } from '@/helpers';
import { GeneralMixin } from '@/mixins';
import { DATE_TYPES } from '@/utils/constants';

export default {
    name: 'VisionList',
    mixins: [GeneralMixin],
    components: {},
    async mounted() {
        await this.onStartup();
        await this.getTeamMembers();
    },
    data() {
        return {
            imageVisionList: [],
            teamMembers: [],
            searchDateFrom: moment()
                .subtract(7, 'd')
                .format(DATE_TYPES.internationalDate),
            selectedTeamMemberId: 0, // 0 means All
            selectedInvalidImageFilterType: 0, // FailedDetection = 0 (no number or parcel), HouseNumberMismatch = 1 (number found but wrong), NoFilter = 2 (show all)
            page: 0
        };
    },
    methods: {
        async onStartup() {
            await this.searchImageVisionList();
        },
        async searchImageVisionList() {
            const params = new URLSearchParams({
                page: this.page,
                take: 20,
                invalidImageFilterType: this.selectedInvalidImageFilterType
            });

            if (this.searchDateFrom) {
                params.append('fromDate', this.searchDateFrom);
            }

            if (this.selectedTeamMemberId > 0) {
                params.append('teamMemberId', this.selectedTeamMemberId);
            }

            const api = `/api/vision/images?${params.toString()}`;

            const payload = {
                method: 'get'
            };
            try {
                const response = await handleRequests(api, payload);
                const result = response.data ? response.data : [];

                this.imageVisionList = result;
            } catch (e) {
                this.imageVisionList = [];
            }
        },
        async getTeamMembers() {
            this.teamMembers = await this.$store.dispatch('team/FETCH_TEAM_MEMBERS', {
                date: null
            });
        }
    },
    watch: {
        searchDateFrom(newVal, oldVal) {
            if (
                moment(newVal).format(DATE_TYPES.internationalDate) ===
                moment(oldVal).format(DATE_TYPES.internationalDate)
            ) {
                return;
            }

            this.searchImageVisionList();
        },
        selectedTeamMemberId(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            this.searchImageVisionList();
        },
        selectedInvalidImageFilterType(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            this.searchImageVisionList();
        }
    }
};
</script>

<style scoped>
.thumbnail-icon {
    max-width: 40px;
    max-height: 40px;
}
</style>
